import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import './styles/variables.css'
import './styles/base.css'
import './styles/buttons.css'

import VueYoutube from 'vue-youtube';
import { setSyncHook } from './services/history';
import VueGtag from 'vue-gtag'
import analytics from './services/analytics'
import ToastPlugin from './plugins/toast'
import { install as installDevLogger } from './devLogger'

if (process.env.NODE_ENV !== 'production') {
  installDevLogger()
}

const ANALYTICS_CONFIG = {
  id: 'G-6CHJLR9MCL',
  appName: 'Effective Shadowing App'
};

Vue.use(VueYoutube);
Vue.use(ToastPlugin);

// Dev shares the prod measurement id, so keep dev out of GA entirely
// (bootstrap:false also stops vue-gtag's automatic page_view).
// ?notrack=1 opts this browser out for good (the owner's own testing was
// most of the data); ?notrack=0 opts back in. landing/index.html reads the same key.
function isNoTrack() {
  try {
    const flag = new URLSearchParams(location.search).get('notrack');
    if (flag === '1') localStorage.setItem('ezshadowNoTrack', '1');
    if (flag === '0') localStorage.removeItem('ezshadowNoTrack');
    return localStorage.getItem('ezshadowNoTrack') === '1';
  } catch (e) { return false; }
}
const GA_ENABLED = !isNoTrack() && process.env.NODE_ENV === 'production';

Vue.use(VueGtag, {
  config: { id: ANALYTICS_CONFIG.id },
  enabled: GA_ENABLED,
  bootstrap: GA_ENABLED
}, router);

analytics.init({
  appName: ANALYTICS_CONFIG.appName,
  provider: 'gtag',
  gtagId: ANALYTICS_CONFIG.id,
  gtagInstance: Vue.prototype.$gtag,
  disabled: !GA_ENABLED
});

Vue.prototype.$analytics = analytics;
window.$analytics = analytics;

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
});

setSyncHook(function() {
  store.dispatch('auth/push').catch(function() {});
});

store.dispatch('auth/restoreSession').catch(function() {});

// Boot-only pulls left an open tab blind to other devices (BUGFIX-008).
var PULL_ON_RETURN_MS = 60000;
var lastReturnPull = Date.now();
document.addEventListener('visibilitychange', function() {
  if (document.hidden || !store.state.auth.user) return;
  if (Date.now() - lastReturnPull < PULL_ON_RETURN_MS) return;
  lastReturnPull = Date.now();
  store.dispatch('auth/pull').catch(function() {});
});
